import { Countdown } from '@frontend/auction/src/helpers/Countdown';
import { TIME } from '@shared/src/utils/time';

export class SPATimer extends HTMLDivElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const minutes = this.querySelector<HTMLElement>('.minutes');
    const seconds = this.querySelector<HTMLElement>('.seconds');
    const milliseconds = this.querySelector<HTMLElement>('.milliseconds');

    if (minutes === null || seconds === null || milliseconds === null) {
      return;
    }

    const countdown = new Countdown({
      time_left: TIME.MINUTE * 10,
      step: Math.floor(TIME.SECOND / 60),
    });

    document.querySelector('[data-control-start]')?.addEventListener('click', () => {
      countdown.start();
    });

    document.querySelector('[data-control-stop]')?.addEventListener('click', () => {
      countdown.stop();
    });

    document.querySelector('[data-control-pause]')?.addEventListener('click', () => {
      countdown.pause();
    });

    Array.from(document.querySelectorAll('[data-control-add-time]')).forEach(element =>
      element.addEventListener('click', event => {
        const addTime = Number((event.currentTarget as HTMLElement).dataset.controlAddTime) || 0;

        countdown.add_time(addTime);
      })
    );

    Array.from(document.querySelectorAll('[data-control-set-time]')).forEach(element =>
      element.addEventListener('click', event => {
        const setTime = Number((event.currentTarget as HTMLElement).dataset.controlSetTime) || 0;

        countdown.set_time(setTime);
      })
    );

    countdown.on_time_change(time => {
      const minutesInnerText = Math.floor(time / 60000)
        .toString()
        .padStart(2, '0');

      if (minutes.innerText !== minutesInnerText) {
        minutes.innerText = minutesInnerText;
      }

      const secondsInnerText = Math.floor((time % 60000) / 1000)
        .toString()
        .padStart(2, '0');

      if (seconds.innerText !== secondsInnerText) {
        seconds.innerText = secondsInnerText;
      }

      milliseconds.innerText = (time % 1_000).toString().padStart(3, '0');
    });
  }
}

customElements.define('spa-timer', SPATimer, { extends: 'div' });
